import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import AuthGate from './AuthGate';
import { BACKEND_URL, IS_DEVELOPMENT, SENTRY_DSN } from './constants/env';

if (!IS_DEVELOPMENT)
  Sentry.init({
    dsn: SENTRY_DSN,
    tunnel: `${BACKEND_URL}/api/sentry/tunnel`
  });

ReactDOM.render(
  <React.StrictMode>
    <AuthGate>
      <App />
    </AuthGate>
  </React.StrictMode>,
  document.getElementById('root')
);
